// extracted by mini-css-extract-plugin
module.exports = {"header":"layout_header__5fN_R"};